import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputField from '#component/form/input';
import { toMeta } from '#helper/rhf-meta';

const readEventValue = event => {
  if (!event?.target) {
    return event;
  }

  return event.target.type === 'checkbox' ? event.target.checked : event.target.value;
};

/**
 * Drives one of the legacy field components (input, checkbox, textarea, ...)
 * from react-hook-form. It keeps the `normalize` / `format` / `onChange` /
 * `onBlur` contract those components were written against, so they can be used
 * inside an RHF form without being rewritten.
 */
const RHFLegacyField = ({
  name,
  component: Component = InputField,
  normalize,
  format,
  onChange: customOnChange,
  onBlur: customOnBlur,
  ...rest
}) => {
  const { control, formState } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const handleChange = event => {
          const raw = readEventValue(event);
          const next = normalize ? normalize(raw, field.value) : raw;
          field.onChange(next);
          customOnChange?.(event, next, field.value, name);
        };

        const handleBlur = event => {
          field.onBlur();
          customOnBlur?.(event, field.value, field.value, name);
        };

        return (
          <Component
            {...field}
            value={format ? format(field.value) : (field.value ?? '')}
            meta={toMeta(fieldState, formState)}
            onChange={handleChange}
            onBlur={handleBlur}
            {...rest}
          />
        );
      }}
    />
  );
};

export default RHFLegacyField;
